import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import { Company } from '../models/company.model';
import {
  selectCompanies,
  selectCurrentPage,
  selectIsLoading,
  selectLimit,
  selectTotalCount,
} from './company.selectors';

@Injectable({ providedIn: 'root' })
export class CompanyListSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly companies: Signal<Company[]> =
    this._store.selectSignal(selectCompanies);
  public readonly totalCount: Signal<number> =
    this._store.selectSignal(selectTotalCount);
  public readonly isLoading: Signal<boolean> =
    this._store.selectSignal(selectIsLoading);
  public readonly currentPage: Signal<number> =
    this._store.selectSignal(selectCurrentPage);
  public readonly limit: Signal<Nullable<number>> =
    this._store.selectSignal(selectLimit);
}
